import request from "@utils/request";

/**
 * 通知客服我上线了
 * @param
 */
export function kefu_api_online(data) {
  return request.get("/kefu/api/online", data, { login: true });
}

/**
 * 通知客服我下线了
 * @param
 */
export function kefu_api_offline(data) {
  return request.get("/kefu/api/offline", data, { login: true });
}

/**
 * 发送文本或表情
 * @param
 */
export function kefu_api_text(data) {
  return request.post("/kefu/api/text", data, { login: true });
}

/**
 * 获取聊天记录
 * @param
 */
export function get_chat_log(data) {
  return request.get("/kefu/api/log", data, { login: true });
}

/**
 * 获取阿里云配置
 * @param
 */
export function group_auth_policy(data) {
  return request.post("/group/auth/policy", data, { login: true });
}

export function authPolicy(data) {
  return request.get("/group/auth/policy", data, { login: true });
}
export function sendPic(data) {
  return request.post("/kefu/api/pic", data, { login: true });
}

/**
 * 实名认证
 * @param
 */
export function auth_add(data) {
  return request.post("/pay/auth/add/", data, { login: true });
}
